// src/components/gestionEvento/CompetitionPreview.js
import React from 'react';
import { Box, Typography, IconButton, Link } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useCompetencia } from '../../context/CompetenciaContext';
import { useParams } from 'react-router-dom';

const CompetitionPreview = () => {
  const { slug } = useParams();
  const { competencias } = useCompetencia();
  const competencia = competencias.find((comp) => comp.slug === slug);
  console.log('Competencia:', competencia);

  if (!competencia) {
    console.error("CompetitionPreview: No se encontró la competencia para mostrar la vista previa.");
    return (
      <Box>
        <Typography variant="h6" color="error">
          Competencia no encontrada para la vista previa.
        </Typography>
      </Box>
    );
  }

  // Construir la URL pública de la competencia usando el slug
  const previewUrl = `${window.location.origin}/${competencia.slug}`;
  console.log("CompetitionPreview - Preview URL:", previewUrl);

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Vista Previa
      </Typography>
      <Box display="flex" alignItems="center" mb={2}>
        <Link href={previewUrl} target="_blank" rel="noopener noreferrer" underline="hover">
          {previewUrl}
        </Link>
        <IconButton href={previewUrl} target="_blank" rel="noopener noreferrer" color="primary">
          <OpenInNewIcon />
        </IconButton>
      </Box>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        A continuación se muestra una vista previa de la página del evento:
      </Typography>
      <Box
        mt={2}
        sx={{ border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden', height: '500px' }}
      >
        <iframe
          title="Vista Previa del Evento"
          src={previewUrl}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      </Box>
    </Box>
  );
};

export default CompetitionPreview;
